import { useState } from 'react'
import { TaskListDwo as TaskListDwoType } from './types/dailyTaskDwo';
import TaskListDwo from './TaskListDwo';
import TaskListDetailsDwo from './TaskListDetailsDwo';

type View = "list" | "details";

const DwoListView = () => {
    const [view, setView] = useState<View>("list");
    const [selectedTask, setSelectedTask] = useState<TaskListDwoType | null>(
      null,
    );

    const handleSelect = (task: TaskListDwoType) => {
      setSelectedTask(task);
      setView("details");
    };

    const handleBack = () => {
      setView("list");
      setSelectedTask(null);
    };

    const renderView = () => {
      switch (view) {
        case "list":
          return <TaskListDwo select={handleSelect} />;
        case "details":
          return <TaskListDetailsDwo back={handleBack} task={selectedTask!} />;
        default:
          <TaskListDwo select={handleSelect} />;
          break;
      }
    };

    return <div>{renderView()}</div>;
}

export default DwoListView